import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Text from "../../utils/commonComponent/Custom/text";
import CommonForm from "../../utils/commonComponent/commonForm";
import {
  CancelButton,
  SaveAndUpdate,
} from "../../utils/commonComponent/Custom/Button";
import {
  fetchByTable,
  fetchQuery,
} from "./../../utils/commonComponent/fetched";
import axiosWithToken from "../../utils/commonComponent/axiosTokenConfig";
import { BASE_URL } from "../../global";
import { getPermissions } from "../rbac/hasAccess";
import { validateRequiredFields } from "../../utils/commonComponent/errorAlert";

const EditHoliday = (props) => {
  const params = useParams();
  const permissions = getPermissions(props.moduleId);
  const navigate = useNavigate();
  const [inputStates, setInputStates] = React.useState({});

  const inputFields = [
    { type: "DatePicker", label: "Date *", stateKey: "date" },
    { type: "TextField", label: "Holiday Name *", stateKey: "holidayName" },
    {
      type: "Autocomplete",
      label: "Holiday Type *",
      stateKey: "holidayType",
      options: [
        { id: 1, name: "Holiday" },
        { id: 2, name: "RestrictedHoliday" },
      ],
      valueKey: "name",
      getOptionLabelKey: "name",
    },
  ];

  const updateInputObject = (key, value) => {
    setInputStates((prevInputStates) => ({
      ...prevInputStates,
      [key]: value,
    }));
  };

  const fetchHolidayDetails = async () => {
    try {
      const [holiday] = await fetchQuery(
        `SELECT * FROM holidayRegister WHERE id = ${params.id}`
      );
      setInputStates(holiday);
    } catch (error) {
      console.error("Error fetching Holiday data:", error);
    }
  };

  const onSubmit = async () => {
    const fieldsToValidate = [
      { value: inputStates.date, label: "Date is required" },
      { value: inputStates.holidayName, label: "Holiday Name is required" },
      { value: inputStates.holidayType, label: "Holiday Type is required" },
    ];

    if (!validateRequiredFields(fieldsToValidate)) {
      return;
    }

    try {
      const url = BASE_URL + `holidayRegister`;
      params.id !== "0"
        ? await axiosWithToken.patch(url + `/${params.id}`, inputStates)
        : await axiosWithToken.post(url, inputStates);

      toast.success(
        params.id !== "0"
          ? "Holiday Updated Successfully!"
          : "Holiday Created Successfully!"
      );
      if (params.id == 0) {
        setTimeout(() => navigate("/master/holiday"), 1000);
      } else {
        setTimeout(() => window.location.reload(), 1000);
      }
    } catch (error) {
      console.error("Submission failed:", error);
    }
  };

  useEffect(() => {
    if (params.id != 0) fetchHolidayDetails();
  }, [params]);

  return (
    <div>
      <Text variant="h3" bold className="text-blue-600">
        {params.id == 0 ? "Create New Holiday" : `Update Holiday `}
      </Text>
      <br />
      <CommonForm
        inputStates={inputStates}
        updateInputObject={updateInputObject}
        inputFields={inputFields}
      />
      <br />
      <div className="flex gap-10 mt-5 justify-end ">
        <CancelButton
          id="btn-cancel"
          label="Cancel"
          outline
          onClick={() => {
            if (window.confirm("Are you sure you want to cancel?")) {
              window.history.back();
            }
          }}
        />
        {(permissions.save || permissions.allAccess) && (
          <SaveAndUpdate
            id="btn-add-outline"
            label={params.id == 0 ? "Save" : "Update"}
            onClick={onSubmit}
          />
        )}
      </div>
    </div>
  );
};

export default EditHoliday;
